import * as THREE from 'three';

export const field = {
  floor: './images/common_images/floors/floor.png',
  ceiling: './images/common_images/ceilings/ceiling.png',
  wall: './images/common_images/walls/wall_no_clouds.png',
  width: 10000,
  height: 5000,
  depth: 10000
};

export const clouds = [
  {
    url: './images/common_images/clouds/cloud1.png',
    position: new THREE.Vector3(5250, 750, -2500),
    scale: new THREE.Vector3(326, 152, 1)
  },
  {
    url: './images/common_images/clouds/cloud2.png',
    position: new THREE.Vector3(437.5, 250, -4250),
    scale: new THREE.Vector3(168, 80, 1)
  },
  {
    url: './images/common_images/clouds/cloud3.png',
    position: new THREE.Vector3(-6562.5, 1250, -3000),
    scale: new THREE.Vector3(403, 166, 1)
  },
  {
    url: './images/common_images/clouds/cloud4.png',
    position: new THREE.Vector3(8750, -200, -3250),
    scale: new THREE.Vector3(163, 47, 1)
  },
  {
    url: './images/common_images/clouds/cloud5.png',
    position: new THREE.Vector3(2625, -400, -4750),
    scale: new THREE.Vector3(47, 21, 1)
  },
  {
    url: './images/common_images/clouds/cloud6.png',
    position: new THREE.Vector3(-3500, -200, -4000),
    scale: new THREE.Vector3(121, 52, 1)
  },
  {
    url: './images/common_images/clouds/cloud7.png',
    position: new THREE.Vector3(-8750, 100, -4750),
    scale: new THREE.Vector3(55, 22, 1)
  }
];

//// PROJECTS

export const projectField = {
  floor: './images/common_images/floors/floor.png',
  ceiling: './images/common_images/ceilings/ceiling_projects.png',
  wall: './images/common_images/walls/wall_projects.png',
  width: 10000,
  height: 5000,
  depth: 10000
};

export const github = {
  model: './models/common_models/github_icon.stl',
  color: '#000000',
  width: '12',
  height: '12',
  depth: '15',
  data: 'GITHUB'
};

export const site = {
  model: './models/common_models/internet_icon.stl',
  color: '#000000',
  width: '12',
  height: '12',
  depth: '15',
  data: 'SITE'
};

//// CONTACT

export const fieldContact = {
  floor: './images/common_images/floors/floor.png',
  ceiling: './images/common_images/ceilings/ceiling.png',
  wall: './images/common_images/ceilings/ceiling.png',
  width: 50000,
  height: 10000,
  depth: 10000,
  position: new THREE.Vector3(0, 2500, 0)
};

export const cloudsContact = [
  {
    url: './images/common_images/clouds/cloud1.png',
    position: new THREE.Vector3(3000, -650, -2500),
    scale: new THREE.Vector3(326, 152, 1)
  },
  {
    url: './images/common_images/clouds/cloud2.png',
    position: new THREE.Vector3(250, 500, -4250),
    scale: new THREE.Vector3(168, 80, 1)
  },
  {
    url: './images/common_images/clouds/cloud3.png',
    position: new THREE.Vector3(-3750, -800, -3000),
    scale: new THREE.Vector3(403, 166, 1)
  },
  {
    url: './images/common_images/clouds/cloud4.png',
    position: new THREE.Vector3(5000, 500, -3250),
    scale: new THREE.Vector3(163, 47, 1)
  },
  {
    url: './images/common_images/clouds/cloud5.png',
    position: new THREE.Vector3(1500, -1400, -4750),
    scale: new THREE.Vector3(47, 21, 1)
  },
  {
    url: './images/common_images/clouds/cloud6.png',
    position: new THREE.Vector3(-2000, -800, -4000),
    scale: new THREE.Vector3(121, 52, 1)
  },
  {
    url: './images/common_images/clouds/cloud7.png',
    position: new THREE.Vector3(-5000, -500, -4750),
    scale: new THREE.Vector3(55, 22, 1)
  }
];

export const githubContact = {
  model: './models/common_models/github_icon.stl',
  color: '#000000',
  width: '15',
  height: '15',
  depth: '15',
  data: 'GITHUB'
};

export const linkedin = {
  model: './models/common_models/linkedin_logo.stl',
  color: '#0E76A8',
  width: '15',
  height: '15',
  depth: '15',
  data: 'LINKEDIN'
};

export const email =   {
  model: './models/common_models/email_icon.stl',
  color: '#000000',
  width: '15',
  height: '15',
  depth: '15',
  data: 'EMAIL'
};

export const resume =   {
  model: './models/common_models/resume_icon.stl',
  color: '#000000',
  width: '15',
  height: '15',
  depth: '15',
  data: 'RESUME'
};

//// HOME

export const project = {
  model: './models/common_models/projects_icon.stl',
  color: '#000000',
  width: '15',
  height: '15',
  depth: '15',
  data: 'PROJECTS'
};

export const tech = {
  model: './models/common_models/tech_icon.stl',
  color: '#000000',
  width: '15',
  height: '15',
  depth: '15',
  data: 'TECH'
};

export const contact = {
  model: './models/common_models/contact_icon.stl',
  color: '#000000',
  width: '15',
  height: '15',
  depth: '15',
  data: 'CONTACT'
};

export const about = {
  model: './models/common_models/about_icon.stl',
  color: '#000000',
  width: '15',
  height: '15',
  depth: '15',
  data: 'ABOUT'
};

//// TECH

export const sky = {
  floor: './images/common_images/ceilings/ceiling.png',
  ceiling: './images/common_images/ceilings/ceiling.png',
  wall: './images/common_images/ceilings/ceiling.png',
  width: 12000,
  height: 5000,
  depth: 15000
};

export const cloudsTech = [
  {
    url: './images/common_images/clouds/cloud1.png',
    position: new THREE.Vector3(3000, 0, -300),
    scale: new THREE.Vector3(326, 152, 1)
  },
  {
    url: './images/common_images/clouds/cloud2.png',
    position: new THREE.Vector3(250, 500, -950),
    scale: new THREE.Vector3(168, 80, 1)
  },
  {
    url: './images/common_images/clouds/cloud3.png',
    position: new THREE.Vector3(-3750, -800, -550),
    scale: new THREE.Vector3(403, 166, 1)
  },
  {
    url: './images/common_images/clouds/cloud4.png',
    position: new THREE.Vector3(5000, 1000, -1150),
    scale: new THREE.Vector3(163, 47, 1)
  },
  {
    url: './images/common_images/clouds/cloud5.png',
    position: new THREE.Vector3(1500, -1400, -1150),
    scale: new THREE.Vector3(47, 21, 1)
  },
  {
    url: './images/common_images/clouds/cloud6.png',
    position: new THREE.Vector3(-2000, 1200, -600),
    scale: new THREE.Vector3(121, 52, 1)
  },
  {
    url: './images/common_images/clouds/cloud7.png',
    position: new THREE.Vector3(-5000, 1000, -1050),
    scale: new THREE.Vector3(55, 22, 1)
  }
];

// STLS FROM SELVA3D.COM
export const techLogos = [
  {
    category: 'Languages',
    models: [
      {
        model: './models/tech_logo_models/typescript_logo.stl',
        color: '#007ACC',
        width: '20',
        height: '20',
        depth: '20',
        name: 'TypeScript',
        position: new THREE.Vector3(1100 * Math.sin(THREE.Math.degToRad(0)), 0, 1100 * Math.cos(THREE.Math.degToRad(0)))
      },
      {
        model: './models/tech_logo_models/javascript_logo.stl',
        color: '#FFFF00',
        width: '20',
        height: '20',
        depth: '20',
        name: 'JavaScript',
        position: new THREE.Vector3(1100 * Math.sin(THREE.Math.degToRad(0)), 0, 1100 * Math.cos(THREE.Math.degToRad(0)))
      },
      {
        model: './models/tech_logo_models/csharp_logo.stl',
        color: '#641F77',
        width: '20',
        height: '20',
        depth: '20',
        name: 'C#',
        position: new THREE.Vector3(1100 * Math.sin(THREE.Math.degToRad(72)), 0, 1100 * Math.cos(THREE.Math.degToRad(72)))
      },
      {
        model: './models/tech_logo_models/html5_logo.stl',
        color: '#DF4B24',
        width: '20',
        height: '20',
        depth: '20',
        name: 'HTML',
        position: new THREE.Vector3(1100 * Math.sin(THREE.Math.degToRad(144)), 0, 1100 * Math.cos(THREE.Math.degToRad(144)))
      },
      {
        model: './models/tech_logo_models/css_logo.stl',
        color: '#254ADF',
        width: '20',
        height: '20',
        depth: '20',
        name: 'CSS',
        position: new THREE.Vector3(1100 * Math.sin(THREE.Math.degToRad(216)), 0, 1100 * Math.cos(THREE.Math.degToRad(216)))
      },
      {
        model: './models/tech_logo_models/graphql_logo.stl',
        color: '#DC0194',
        width: '20',
        height: '20',
        depth: '20',
        name: 'GraphQL',
        position: new THREE.Vector3(1100 * Math.sin(THREE.Math.degToRad(216)), 0, 1100 * Math.cos(THREE.Math.degToRad(216)))
      },
      {
        model: './models/tech_logo_models/max7_logo.stl',
        color: '#53565D',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Max/MSP',
        position: new THREE.Vector3(1100 * Math.sin(THREE.Math.degToRad(288)), 0, 1100 * Math.cos(THREE.Math.degToRad(288)))
      }
    ],
  },
  {
    category: 'Front-End',
    models: [
      {
        model: './models/tech_logo_models/react_logo.stl',
        color: '#5FD5F5',
        width: '20',
        height: '20',
        depth: '20',
        name: 'React'
      },
      {
        model: './models/tech_logo_models/redux_logo.stl',
        color: '#7D41C8',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Redux'
      },
      {
        model: './models/tech_logo_models/nextjs_logo.stl',
        color: '#000000',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Next.js'
      },
      {
        model: './models/tech_logo_models/amplify_logo.stl',
        color: '#FFAC00',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Amplify'
      },
      {
        model: './models/tech_logo_models/threejs_logo.stl',
        color: '#3FB280',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Three.js'
      },
      {
        model: './models/tech_logo_models/sass_logo.stl',
        color: '#CD669A',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Sass'
      },
      {
        model: './models/tech_logo_models/materialui_logo.stl',
        color: '#04B0FF',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Material-UI'
      }
    ]
  },
  {
    category: 'Back-End',
    models: [
      {
        model: './models/tech_logo_models/node_logo.stl',
        color: '#8CC03C',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Node.js'
      },
      {
        model: './models/tech_logo_models/express_logo.stl',
        color: '#868686',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Express'
      },
      {
        model: './models/tech_logo_models/socket_logo.stl',
        color: '#000000',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Socket.IO'
      },
      {
        model: './models/tech_logo_models/cheerio_logo.stl',
        color: '#BC9A65',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Cheerio'
      }
    ]
  },
  {
    category: 'Databases',
    models: [
      {
        model: './models/tech_logo_models/mysql_logo.stl',
        color: '#00758F',
        width: '20',
        height: '20',
        depth: '20',
        name: 'MySQL'
      },
      {
        model: './models/tech_logo_models/postgresql_logo.stl',
        color: '#31638C',
        width: '20',
        height: '20',
        depth: '20',
        name: 'PostgreSQL'
      },
      {
        model: './models/tech_logo_models/redis_logo.stl',
        color: '#D82C20',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Redis'
      },
      {
        model: './models/tech_logo_models/mongodb_logo.stl',
        color: '#429643',
        width: '20',
        height: '20',
        depth: '20',
        name: 'MongoDB'
      },
      {
        model: './models/tech_logo_models/dynamo_logo.stl',
        color: '#2D72B8',
        width: '20',
        height: '20',
        depth: '20',
        name: 'DynamoDB'
      }
    ]
  },
  {
    category: 'Testing',
    models: [
      {
        model: './models/tech_logo_models/qunit_logo.stl',
        color: '#9E2F97',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Q-Unit'
      },
      {
        model: './models/tech_logo_models/jest_logo.stl',
        color: '#C63D15',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Jest'
      },
      {
        model: './models/tech_logo_models/travis_logo.stl',
        color: '#C6334A',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Travis CI'
      }
    ],
  },
  {
    category: 'Tools',
    models: [
      {
        model: './models/common_models/github_icon.stl',
        color: '#000000',
        width: '20',
        height: '20',
        depth: '20',
        name: 'GitHub'
      },
      {
        model: './models/tech_logo_models/aws_logo.stl',
        color: '#FF9A00',
        width: '20',
        height: '20',
        depth: '20',
        name: 'AWS'
      },
      {
        model: './models/tech_logo_models/vscode_logo.stl',
        color: '#22A3EC',
        width: '20',
        height: '20',
        depth: '20',
        name: 'VS Code'
      },
      {
        model: './models/tech_logo_models/heroku_logo.stl',
        color: '#8B6FBE',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Heroku'
      },
      {
        model: './models/tech_logo_models/netlify_logo.stl',
        color: '#32AEB5',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Netlify'
      },
      {
        model: './models/tech_logo_models/postman_logo.stl',
        color: '#EB5823',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Postman'
      },
      {
        model: './models/tech_logo_models/unity_logo.stl',
        color: '#000000',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Unity'
      },
      {
        model: './models/tech_logo_models/protools_logo.stl',
        color: '#7927ED',
        width: '20',
        height: '20',
        depth: '20',
        name: 'Pro Tools'
      }
    ]
  }
];
